import React from 'react';
import { MenuBar, MenuBarContainer } from './menu-bar/MenuBar.styled';
import { StyledMenuBarLink, StyledMenuBarButton } from './menu-bar/MenuBarItem.styled';
import { StyledNavigation } from './Navigation.styled';
import { NavigationPanel } from './navigation-panel/NavigationPanel.styled';
import { StyledNavPanelLink, StyledNavPanelButton } from './navigation-panel/NavigationPanelItem.styled';
import { Unread } from './Unread.styled';
import { Logo } from '../../logo';
import { Chip } from '../../chip';
export const generateTargetValue = (url) => url.startsWith('http') ? '_blank' : '';
/**
 * Higher order function, creating a component that renders the appropriate UI element
 * for the type of navigation item given to it as a prop.
 * Additionally, it will augment any supplied callback event with its own, which is how we make sure
 * that selecting navigation items will close the menu as a side effect.
 * @param link The component to be rendered if the nav item supplied is a link (i.e. has a URL)
 * @param button  The component to be rendered if the nav item supplied is a button (i.e. has a callback fn)
 * @returns A React component that conditionally renders a button or a link depending on the supplied nav item.
 */
const linkOrButtonItem = (link, button) => ({ item }) => {
    const { icon } = item;
    const children = React.createElement(React.Fragment, null,
        !!icon && (typeof icon === 'string' ? React.createElement("img", { src: icon, alt: item.label }) : React.createElement(React.Fragment, null, icon)),
        React.createElement("span", { className: "label" }, item.label),
        item.chipText && React.createElement("div", { style: { marginRight: item.unread ? '4px' : 0 } },
            React.createElement(Chip, { text: item.chipText, transparent: true })),
        item.unread && React.createElement(Unread, { className: "unread" }, item.unread > 9 ? '9+' : item.unread));
    if ('url' in item) {
        const LinkItem = link;
        return React.createElement(LinkItem, { highlighted: !!item.isHighlighted, href: item.url, target: generateTargetValue(item.url) }, children);
    }
    else {
        const ButtonItem = button;
        return React.createElement(ButtonItem, { highlighted: !!item.isHighlighted, onClick: item.callback }, children);
    }
};
const MenuBarItem = linkOrButtonItem(StyledMenuBarLink, StyledMenuBarButton);
const NavItem = linkOrButtonItem(StyledNavPanelLink, StyledNavPanelButton);
/**
 * Renders all site navigation items for the application.
 * On mobile, the menu bar is rendered at the bottom of the viewport,
 * and the navigation panel can be opened for further nav options.
 * On desktop, only the navigation panel is rendered.
 */
const ProductNav = ({ navigation, subnavigation, menu }) => {
    return React.createElement(StyledNavigation, null,
        React.createElement(MenuBarContainer, null,
            React.createElement(MenuBar, { id: "product-menu-bar" }, menu.map((item, i) => (React.createElement("li", { key: item.label + i.toString() },
                React.createElement(MenuBarItem, { item: item })))))),
        React.createElement(NavigationPanel, { id: "product-navigation-panel" },
            React.createElement("a", { className: "logo", href: "/" },
                React.createElement(Logo, { color: "lightbg", height: 18, type: "full" })),
            React.createElement("ul", { className: "navigation" }, navigation.map((item, i) => (React.createElement("li", { key: item.label + i.toString() },
                React.createElement(NavItem, { item: item }))))),
            subnavigation.length < 1 ? null : React.createElement("ul", { className: "subnavigation" }, subnavigation.map((item, i) => (React.createElement("li", { key: item.label + i.toString() },
                React.createElement(NavItem, { item: item })))))));
};
export default ProductNav;
//# sourceMappingURL=index.js.map